export default {
  fields: [
    {
      data: 'amount',
      developerNote:
        'The total payable amount of the invoice or receipt. Must include all taxes and fees. Represented as a decimal number in the invoice currency (no currency symbol).',
      example: 1250.75,
    },
    {
      data: 'currency',
      developerNote: 'Three-letter ISO 4217 currency code for the invoice amount (e.g. EUR, USD, BRL, GBP).',
      example: 'USD',
    },
    {
      data: 'beneficiaryName',
      developerNote:
        'Full legal name of the seller, beneficiary, or payee who receives the payment on the invoice. Do not use the buyer/payer name.',
      example: 'FinTech México S.A. de C.V.',
    },
    {
      data: 'beneficiaryEmail',
      developerNote: 'Email address of the beneficiary used for payment or contact on the invoice.',
      example: 'payments@example.com',
    },
    {
      data: 'pixKey',
      developerNote: 'PIX key for Brazil instant payments (phone, email, CPF, CNPJ, or random key), if present on the invoice.',
      example: 'payments@example.com',
    },
    {
      data: 'paymentReference',
      developerNote:
        'A unique, human-readable payment reference shown to the payer. This value must be entered exactly as provided when initiating the payment to ensure correct reconciliation.',
      example: 'INV-2024-00983',
    },
    {
      data: 'paymentPurpose',
      developerNote:
        'A predefined classification describing why the payment is made. Used for reporting and downstream processing. Must be one of the supported enum values.',
      values: [
        {
          data: 'capital_contributions',
          label: 'Capital Contributions',
        },
        {
          data: 'charitable_contributions',
          label: 'Charitable Contributions',
        },
        {
          data: 'consulting_fees',
          label: 'Consulting Fees',
        },
        {
          data: 'corporate_tax_payments',
          label: 'Corporate Tax Payments',
        },
        {
          data: 'down_payments_for_real_estate',
          label: 'Down Payments For Real Estate',
        },
        {
          data: 'education_fees',
          label: 'Education Fees',
        },
        {
          data: 'employee_salaries_or_wages',
          label: 'Employee Salaries Or Wages',
        },
        {
          data: 'expenses_reimbursement',
          label: 'Expenses Reimbursement',
        },
        {
          data: 'gifts',
          label: 'Gifts',
        },
        {
          data: 'government_grants',
          label: 'Government Grants',
        },
        {
          data: 'income_tax_payments',
          label: 'Income Tax Payments',
        },
        {
          data: 'inheritance_payments',
          label: 'Inheritance Payments',
        },
        {
          data: 'insurance_claim_payouts',
          label: 'Insurance Claim Payouts',
        },
        {
          data: 'insurance_premium_payments',
          label: 'Insurance Premium Payments',
        },
        {
          data: 'investments',
          label: 'Investments',
        },
        {
          data: 'loan_advances',
          label: 'Loan Advances',
        },
        {
          data: 'mortgage_payments',
          label: 'Mortgage Payments',
        },
        {
          data: 'other',
          label: 'Other',
        },
        {
          data: 'payment_for_goods_and_services',
          label: 'Payment For Goods And Services',
        },
        {
          data: 'personal_transfers',
          label: 'Personal Transfers',
        },
        {
          data: 'real_estate_purchases',
          label: 'Real Estate Purchases',
        },
        {
          data: 'remittances',
          label: 'Remittances',
        },
        {
          data: 'rent',
          label: 'Rent',
        },
        {
          data: 'repayment_of_loans',
          label: 'Repayment Of Loans',
        },
        {
          data: 'royalties',
          label: 'Royalties',
        },
        {
          data: 'trust_fund_distributions',
          label: 'Trust Fund Distributions',
        },
        {
          data: 'utility_bills',
          label: 'Utility Bills',
        },
        {
          data: 'welfare_or_benefits',
          label: 'Welfare Or Benefits',
        },
        {
          data: 'winnings_and_prizes',
          label: 'Winnings And Prizes',
        },
      ],
    },
    {
      data: 'documentType',
      developerNote:
        'Indicates the type of billing document associated with the payment. Determines validation rules and legal handling. Must be one of the supported enum values.',
      values: [
        {
          data: 'invoice',
          label: 'Invoice',
        },
        {
          data: 'purchase_order',
          label: 'Purchase Order',
        },
        {
          data: 'delivery_slip',
          label: 'Delivery Slip',
        },
        {
          data: 'contract',
          label: 'Contract',
        },
        {
          data: 'bill_of_lading',
          label: 'Bill Of Lading',
        },
        {
          data: 'others',
          label: 'Others',
        },
      ],
    },
    {
      data: 'documentId',
      developerNote:
        'The unique identifier of the billing document in the originating system. Used for idempotency, reconciliation, and audit purposes. Must be stable and unique per document.',
      example: 'INV-2024-00983',
    },
  ],
};
